export default{
    data() {
        return {
            teamTableHeader: [
                {prop: 'sortNo', label: this.$t('showFraction.XH'),width: '80'},
                {prop: 'teamName', label: this.$t('showFraction.TDMC')},
                {prop: 'maxScore', label: this.$t('showFraction.TDZGF')},
                {prop: 'minScore', label: this.$t('showFraction.TDZDF')},
                {prop: 'times', label: this.$t('showFraction.LXCS')},
                {prop: 'operation', label: this.$t('showFraction.CZ'),SlotType:{
                    buttons:[
                      {
                        name: this.$t('showFraction.CK'),
                        isShow: ['isAbsent',0,1],
                        emitName: 'show' // 事件Type 必传
                      }
                    ]
                }}
            ],
            planId: null,
            stData: {
                itemList: []
            }
        }
    },
    created() {
        let { id, planId } = JSON.parse(this.__Base64.decode(this.$route.query.q))
        this.planId = id || planId
    },
    methods: {
        operation(type,rowData){
            if(type === 'show'){
                let { pattern_lx } = JSON.parse(this.__Base64.decode(this.$route.query.q))
                let q = this.__Base64.encode(JSON.stringify({
                    pattern_lx,
                    planId: rowData.planId,
                    teamId: rowData.teamId
                }))
                sessionStorage.setItem('teamDetailUrl',JSON.stringify(this.$route.fullPath))
                this.$router.push(`/teamFraction?q=${q}`)
            }
        }
    },
}